import React from 'react';

/**
 * Standard page wrapper for employee-side pages — provides the page header
 * (eyebrow + title + optional subtitle) and the consistent padded background
 * that the old dashboard tab shell used to provide.
 */
export default function EmployeePage({ eyebrow = 'Employee Portal', title, subtitle, children }) {
  return (
    <div className="p-7 space-y-6 bg-[#F8FAFC]">
      <div>
        <p className="label-meta mb-1">{eyebrow}</p>
        <h1 className="heading-md text-[#1F2937]">{title}</h1>
        {subtitle && <p className="text-[#6B7280] text-sm mt-1">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}
